import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from '@mui/material';

interface SpendSummaryTableProps {
  totalTokens: number;
  sms: {
    totalSMSCountForDateRange?: number;
    totalSMSCount: number;
  };
  email?: {
    totalEmailCountForDateRange?: number;
    totalEmailCount: number;
  };
  credits: {
    total: number;
    used: number;
    remaining: number;
  };
  bookingEnabled?: boolean;
}
// TODO: For future use, please use this to show the number in a more compact format
export function formatCompactNumber(num: number): string {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + ' M';
  }
  if (num >= 1_000) {
    return num.toLocaleString();
  }
  return num.toString();
}

const SpendSummaryTable = ({
  totalTokens,
  sms,
  email,
  credits,
  bookingEnabled,
}: SpendSummaryTableProps) => {
  return (
    <TableContainer component={Paper} elevation={0}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1, textSpacing: -1, px: 2 }}>
        Usage Summary
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography fontWeight={700} fontSize="1.4rem" color="#9685FF">
                Credits
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Box display="flex" justifyContent="flex-end" alignItems="baseline" gap={0.5}>
                <Typography fontWeight={700} fontSize="1.4rem" color="primary.main">
                  {credits?.remaining?.toFixed(1)}
                </Typography>
                <Typography color="text.secondary" fontSize="0.6rem">
                  /{credits?.total?.toFixed(1)}
                </Typography>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ py: 1.5, color: 'text.secondary' }}> Tokens Used</TableCell>
            <TableCell sx={{ py: 1.5, color: 'text.secondary' }} align="right">
              {/* {formatCompactNumber(totalTokens)} */}
              {totalTokens.toLocaleString()}
            </TableCell>
          </TableRow>
          {bookingEnabled && (
            <>
              <TableRow>
                <TableCell sx={{ py: 1.5, color: 'text.secondary' }}> SMS Sent</TableCell>
                <TableCell sx={{ py: 1.5, color: 'text.secondary' }} align="right">
                  {sms?.totalSMSCountForDateRange?.toLocaleString() || 0}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ py: 1.5, color: 'text.secondary' }}> Mail Sent</TableCell>
                <TableCell sx={{ py: 1.5, color: 'text.secondary' }} align="right">
                  {email?.totalEmailCountForDateRange?.toLocaleString() || 0}
                </TableCell>
              </TableRow>
            </>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SpendSummaryTable;
